import { Icons } from '@/components/Shares/Icons';
import { type STATUS, useVerifyAction } from '@/providers/VerifyActionProvider';
import { useLingui } from '@lingui/react';
import { Box, Flex, Stack, Text } from '@mantine/core';
import classes from './Kyc.module.css';
export type KycStepperItemProps = {
  title: string;
  itemStatus: STATUS;
  success: STATUS;
};
export const KycStepperItem: React.FC<KycStepperItemProps> = ({
  title,
  itemStatus,
  success
}) => {
  const {
    status,
    successes
  } = useVerifyAction();
  const {
    i18n
  } = useLingui();
  return <Stack gap={11} align="center">
      <Box w="100%" className={status === itemStatus && !successes.has(itemStatus) ? classes.progress : classes.step}>
        <Flex h={40} m={4} gap={{
        base: 4,
        sm: 10
      }} direction={{
        base: 'column-reverse',
        sm: 'row'
      }} justify="center" align="center" bd={status === itemStatus && !successes.has(itemStatus) ? '1px solid var(--bg-100)' : 'transparent'}>
          <Text fz={{
          base: 9,
          sm: 13
        }} fw={700} c={successes.has(success) ? 'var(--text-green)' : status === itemStatus && !successes.has(itemStatus) ? 'var(--bg-100)' : 'var(--icon-primary)'} tt="uppercase" ta="center">
            {title}
          </Text>
          {successes.has(success) && <Icons color="var(--text-green)" className="icon-pr-line-checked" />}
        </Flex>
      </Box>

      {!successes.has(success) && status !== itemStatus && <Text fz={{
      base: 10,
      sm: 13
    }} tt="uppercase" c="var(--icon-primary)" fw={700}>
          {i18n._('Pending')}
        </Text>}

      {status === itemStatus && !successes.has(itemStatus) && <Text fz={{
      base: 10,
      sm: 13
    }} tt="uppercase" c="var(--text-prime)" fw={700} ta="center">
          {i18n._('In process')}
        </Text>}
    </Stack>;
};